import React from 'react';

const ArrowDown = props => (
  <svg width={24} height={24} {...props}>
    <path d="M1 8h22l-11 9z" fillRule="evenodd" />
  </svg>
);

export default ArrowDown;
